var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { AppState } from "@/share/AppState";
import { LetrRequestType } from "@/share/Letr";
import { FileProcessItemStatus } from "@@/File";
import { action, makeObservable, observable } from "mobx";
import { Router } from "./Router";
export const HomeTile = { title: 'Home', key: 'home' };
export class HomeViewStore {
    constructor() {
        this.activeTab = 'letrs';
        this.initalload = true;
        this.newnotifycount = 0;
        this.newtaskcount = 0;
        this.newfilecount = 0;
        this.shownewfileview = false;
        this.shownotifyview = false;
        this.logs = new Map();
        this.tasks = new Map();
        this.newfiles = new Map();
        this.showtasks = false;
        this.gettinglogs = false;
        this.gettingtasks = false;
        this.gettingfiles = false;
        this.hasmorelogs = false;
        this.hasmoretask = false;
        this.hasmorefiles = false;
        this.loadingbottomlogs = false;
        this.loadingbottomtasks = false;
        this.loadingbottomfiles = false;
        this.lastlogtime = new Date().getTime();
        this.recentone = 0;
        this.lasttasktime = new Date().getTime();
        this.recentasktime = 0;
        this.lastfiletime = new Date().getTime();
        this.recentfiletime = 0;
        this.loadedtaks = false;
        this.activeTile = { title: 'Letrs', key: 'letrs' };
        makeObservable(this);
        APPEvent.addSubscriberForProcessingFiles((fs) => {
            console.log(fs);
            fs.files.forEach((ts) => this.addFile(ts));
            if (fs.reverse) {
                this.setGettingFiles(false);
            }
            if (!fs.reverse) {
                this.setLoadingBottomFiles(false);
                if (fs.files.length < 20) {
                    this.setHasMoreTasks(false);
                }
            }
        });
        APPEvent.addSubscriberForAppState((st) => {
            if (st === AppState.LoggedIn) {
                setTimeout(() => {
                    const rout = Router.getActiveRoute();
                    if ((rout === null || rout === void 0 ? void 0 : rout.tab) === "Contacts") {
                        this.setActiveTab("contacts");
                    }
                    else if ((rout === null || rout === void 0 ? void 0 : rout.tab) === "Devices") {
                        this.setActiveTab("devices");
                    }
                    else if ((rout === null || rout === void 0 ? void 0 : rout.tab) === "Search") {
                        this.setActiveTab("search");
                    }
                }, 100);
                this.setHasMoreLogs(true);
                this.lastlogtime = new Date().getTime();
                this.recentone = 0;
                this.lasttasktime = new Date().getTime();
                this.recentasktime = 0;
                this.setHasMoreTasks(true);
                this.lastfiletime = new Date().getTime();
                this.recentfiletime = 0;
            }
            else {
                this.setNewNotifyCount(0);
                this.setnewtaskcount(0);
                this.setNewFilesCount(0);
            }
        });
        APPEvent.addSubscriberForLetrsResponse(lres => {
            if (lres.type === LetrRequestType.Fetch) {
            }
        });
        APPEvent.addSubscriberForAssignedTasksCount(ct => {
            if (this.showtasks) {
                if (ct > 0) {
                    this.getAssignedTasks(true);
                }
            }
            this.setnewtaskcount(ct);
        });
        APPEvent.addSubscriberForNewFileCount(ct => {
            if (this.shownewfileview) {
                if (ct > 0) {
                    this.getFiles(true);
                }
            }
            this.setNewFilesCount(ct);
        });
        APPEvent.addSubscriberForNewNotifyCount((ct) => {
            if (this.shownotifyview) {
                if (ct.count > 0) {
                    this.getRecentLogs(true);
                }
            }
            this.setNewNotifyCount(ct.count);
        });
        APPEvent.addSubscriberForRecentLogs((lgs) => {
            lgs.logs.forEach((lg) => {
                this.addLog(lg);
            });
            if (lgs.reverse) {
                this.setGettingLogs(false);
            }
            if (!lgs.reverse) {
                this.setLoadingBottomLogs(false);
                if (lgs.logs.length < 20) {
                    this.setHasMoreLogs(false);
                }
            }
        });
        APPEvent.addSubscriberForAssignedTasks((tsks) => {
            tsks.logs.forEach((ts) => this.addTask(ts));
            if (tsks.reverse) {
                this.setGettingTasks(false);
            }
            if (!tsks.reverse) {
                this.setLoadingBottomTask(false);
                if (tsks.logs.length < 20) {
                    this.setHasMoreTasks(false);
                }
            }
        });
        APPEvent.addSubscriberForNewAssignedTasks((tsk) => {
            tsk.forEach(tk => this.addTask(tk));
        });
    }
    setHasMoreLogs(has) {
        this.hasmorelogs = has;
    }
    setHasMoreTasks(has) {
        this.hasmoretask = has;
    }
    setHasMoreFiles(has) {
        this.hasmorefiles = has;
    }
    setShowFiles(show) {
        this.shownewfileview = show;
    }
    setNewFilesCount(count) {
        this.newfilecount = count;
    }
    setActiveTab(tile) {
        APPEvent.publishActiveLetr("");
        this.activeTab = tile;
        if (this.activeTab === "contacts") {
            Router.setContactView();
        }
        else if (this.activeTab === "devices") {
            Router.setDevicesView();
        }
        else if (this.activeTab === "search") {
            Router.setSearchView();
        }
    }
    setActiveTile(tile) {
        this.activeTile = tile;
    }
    addLog(log) {
        this.logs.set(log.id, log);
        if (this.lastlogtime == 0 || this.lastlogtime > log.entrytime) {
            this.lastlogtime = log.entrytime;
        }
        if (this.recentone == 0 || this.recentone < log.entrytime) {
            this.recentone = log.entrytime;
        }
    }
    addTask(log) {
        this.tasks.set(log.id, log);
        if (this.lasttasktime == 0 || this.lasttasktime > log.updatetime) {
            this.lasttasktime = log.updatetime;
        }
        if (this.recentasktime == 0 || this.recentasktime < log.updatetime) {
            this.recentasktime = log.updatetime;
        }
    }
    addFile(file) {
        this.newfiles.set(file.id, file);
        if (this.lastfiletime == 0 || this.lastfiletime > file.updatetime) {
            this.lastfiletime = file.updatetime;
        }
        if (this.recentfiletime == 0 || this.recentfiletime < file.updatetime) {
            this.recentfiletime = file.updatetime;
        }
    }
    clearLog() {
        this.logs.clear();
    }
    clearTasks() {
        this.tasks.clear();
    }
    clearFiles() {
        this.newfiles.clear();
    }
    setnewtaskcount(count) {
        this.newtaskcount = count;
    }
    setNewNotifyCount(count) {
        this.newnotifycount = count;
    }
    setGettingLogs(getting) {
        this.gettinglogs = getting;
    }
    setGettingTasks(getting) {
        this.gettingtasks = getting;
    }
    setGettingFiles(getting) {
        this.gettingfiles = getting;
    }
    setShowNotifyView(show) {
        this.shownotifyview = show;
    }
    setShowTaskView(show) {
        this.showtasks = show;
    }
    setLoadingBottomLogs(loading) {
        this.loadingbottomlogs = loading;
    }
    setLoadingBottomTask(loading) {
        this.loadingbottomtasks = loading;
    }
    setLoadingBottomFiles(loading) {
        this.loadingbottomfiles = loading;
    }
    getFiles(reverse = false) {
        if (reverse && this.gettingfiles) {
            return;
        }
        if (!reverse && this.loadingbottomfiles) {
            return;
        }
        if (reverse) {
            this.setGettingFiles(true);
        }
        else {
            this.setLoadingBottomFiles(true);
        }
        let time = this.lastfiletime;
        if (reverse) {
            if (this.recentfiletime === 0) {
                this.recentfiletime = new Date().getTime();
            }
            time = this.recentfiletime;
        }
        const req = {
            reverse: reverse,
            since: this.lastfiletime,
            count: reverse ? 1000 : 20,
            ignids: Array.from(this.newfiles.values()).filter((vl) => vl.updatetime === time && (vl.status == FileProcessItemStatus.Done)).map((en) => en.id),
        };
        Apphandler.sendMessage("processingfiles", req);
    }
    getAssignedTasks(reverse = false) {
        if (reverse && this.gettingtasks) {
            return;
        }
        if (!reverse && this.loadingbottomtasks) {
            return;
        }
        if (reverse) {
            this.setGettingTasks(true);
        }
        else {
            this.setLoadingBottomTask(true);
        }
        let time = this.lasttasktime;
        if (reverse) {
            if (this.recentasktime === 0) {
                this.recentasktime = new Date().getTime();
            }
            time = this.recentasktime;
        }
        const req = {
            reverse: reverse,
            request: time,
            ignorids: Array.from(this.tasks.values()).filter((vl) => vl.updatetime === time).map((en) => en.id),
            letrid: "",
            count: reverse ? 10000 : 20
        };
        Apphandler.sendMessage("assignedtask", req);
    }
    getNewTasks() {
        Apphandler.sendMessage("newassignedtasks", "get");
    }
    getRecentLogs(reverse = false) {
        if (reverse && this.gettinglogs) {
            return;
        }
        if (!reverse && this.loadingbottomlogs) {
            return;
        }
        if (reverse) {
            this.setGettingLogs(true);
        }
        else {
            this.setLoadingBottomLogs(true);
        }
        let time = this.lastlogtime;
        if (reverse) {
            if (this.recentone === 0) {
                this.recentone = new Date().getTime();
            }
            time = this.recentone;
        }
        const req = {
            reverse: reverse,
            request: time,
            ignorids: Array.from(this.logs.values()).filter((vl) => vl.entrytime === time).map((en) => en.id),
            letrid: "",
            count: reverse ? 10000 : 20
        };
        Apphandler.sendMessage("getupdatelogs", req);
    }
    reset() {
        this.setActiveTab('letrs');
        this.setNewNotifyCount(0);
        this.setNewFilesCount(0);
        this.setShowFiles(false);
        this.setShowNotifyView(false);
        this.clearLog();
        this.clearTasks();
        this.clearFiles();
        this.setShowTaskView(false);
        this.setGettingLogs(false);
        this.setGettingTasks(false);
        this.setGettingFiles(false);
        this.lastlogtime = new Date().getTime();
        this.recentone = 0;
        this.lasttasktime = new Date().getTime();
        this.recentasktime = 0;
        this.lastfiletime = new Date().getTime();
        this.recentfiletime = 0;
        this.setHasMoreLogs(true);
        this.setHasMoreTasks(true);
        this.setLoadingBottomLogs(false);
        this.setLoadingBottomTask(false);
    }
}
__decorate([
    observable,
    __metadata("design:type", String)
], HomeViewStore.prototype, "activeTab", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], HomeViewStore.prototype, "newnotifycount", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], HomeViewStore.prototype, "newtaskcount", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], HomeViewStore.prototype, "newfilecount", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], HomeViewStore.prototype, "shownewfileview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], HomeViewStore.prototype, "shownotifyview", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], HomeViewStore.prototype, "logs", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], HomeViewStore.prototype, "tasks", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], HomeViewStore.prototype, "newfiles", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], HomeViewStore.prototype, "showtasks", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], HomeViewStore.prototype, "gettinglogs", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], HomeViewStore.prototype, "gettingtasks", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], HomeViewStore.prototype, "gettingfiles", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], HomeViewStore.prototype, "hasmorelogs", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], HomeViewStore.prototype, "hasmoretask", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], HomeViewStore.prototype, "hasmorefiles", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], HomeViewStore.prototype, "loadingbottomlogs", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], HomeViewStore.prototype, "loadingbottomtasks", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], HomeViewStore.prototype, "loadingbottomfiles", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], HomeViewStore.prototype, "activeTile", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "setHasMoreLogs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "setHasMoreTasks", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "setHasMoreFiles", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "setShowFiles", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "setNewFilesCount", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "setActiveTab", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "setActiveTile", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "addLog", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "addTask", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "addFile", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "clearLog", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "clearTasks", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "clearFiles", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "setnewtaskcount", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "setNewNotifyCount", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "setGettingLogs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "setGettingTasks", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "setGettingFiles", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "setShowNotifyView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "setShowTaskView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "setLoadingBottomLogs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "setLoadingBottomTask", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], HomeViewStore.prototype, "setLoadingBottomFiles", null);
